//v1.0 - HTML loader for loading scripts in
import { Loader } from './Loader';

export class ImageLoader extends Loader {
	public element: NodeListOf<HTMLImageElement>;

	protected loaded: number = 0;

	public load(): void {
		for (var i = 0; i < this.element.length; i++) {
			this._addListener(this.element[i]);
		}
	}

	public getTotalAssets(): number {
		return this.element ? this.element.length : 0;
	}

	public getLoadedAssets(): number {
		return this.loaded;
	}

	//private
	//--------------------------------------------------------
	//--------------------------------------------------------
	//--------------------------------------------------------
	//--------------------------------------------------------

	protected onImgLoaded(img: any): void {
		this.loaded++;
		this.assetLoaded(img);

		img.removeEventListener('load', (e) => this._onImgLoaded(e.target));
		img.removeEventListener('error', (error) => this._onImgError(error));

		let totalAssets = this.getTotalAssets();
		let loadedAssets = this.getLoadedAssets();
		let ratio = loadedAssets / totalAssets;

		this.progress({
			id: this.id,
			ratio: ratio,
			total: totalAssets,
			loaded: loadedAssets
		});

		if (totalAssets === loadedAssets) {
			this.complete(this.id);
		}
	}

	protected onImgError(error: any): void {
		this.onError(error);
	}

	protected _onImgLoaded(target: any): void {}
	protected _onImgError(error: string): void {}

	private _addListener(img: HTMLImageElement): void {
		if (img.complete) {
			this.onImgLoaded(img);
		} else {
			img.addEventListener('load', (e) => this.onImgLoaded(e.target));
			img.addEventListener('error', (error) => this.onImgError(error));
		}
	}
}
